module.exports = __webpack_public_path__ + "img/Hogwarts.5cf1bd0f.jpg";